import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const Modal = ({
  title,
  onClose,
  onSubmit,
  submitButtonText,
  showCancel,
  showSubmitButton,
  children,
  className = "",
  submitButtonClass = "bg-indigo-600 hover:bg-indigo-700 text-white",
  disableSubmit = false,
}) => {
  const canClose = typeof onClose === "function" && !disableSubmit;

  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm px-4 py-4 sm:px-6">
      <div
        className={`relative max-h-[95dvh] w-full max-w-lg rounded-xl bg-white p-6 shadow-xl ${className}`}
      >
        {/* 🔵 Loading Overlay */}
        {disableSubmit && (
          <div className="absolute inset-0 z-20 flex items-center justify-center rounded-xl bg-white/70 backdrop-blur-sm">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-300 border-t-slate-900"></div>
          </div>
        )}

        <button
          type="button"
          onClick={canClose ? onClose : undefined}
          disabled={!canClose}
          className={`absolute right-4 top-4 transition ${
            canClose
              ? "text-slate-400 hover:text-slate-700"
              : "cursor-not-allowed text-slate-300"
          }`}
        >
          <i className="fas fa-times text-lg"></i>
        </button>

        {title && (
          <h2 className="mb-4 text-lg font-semibold text-slate-800">
            {title}
          </h2>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          {children}

          {(showCancel || showSubmitButton) && (
            <div className="flex justify-end gap-2 pt-2">
              {showCancel && (
                <button
                  type="button"
                  onClick={canClose ? onClose : undefined}
                  disabled={!canClose}
                  className={`rounded-lg px-4 py-2 transition ${
                    canClose
                      ? "bg-slate-200 text-slate-700 hover:bg-slate-300"
                      : "cursor-not-allowed bg-slate-100 text-slate-400"
                  }`}
                >
                  Cancel
                </button>
              )}

              {showSubmitButton && (
                <button
                  type="submit"
                  disabled={disableSubmit}
                  className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 transition ${
                    disableSubmit
                      ? "cursor-not-allowed bg-slate-300 text-white"
                      : submitButtonClass
                  }`}
                >
                  {disableSubmit && (
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
                  )}
                  {submitButtonText}
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );

  return mounted ? createPortal(modalContent, document.body) : null;
};

export default Modal;